import { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';

const HOME_SECTION_IDS = new Set([
  'hero',
  'competences',
  'projets',
  'parcours',
  'certifications',
  'contact',
]);

const scrollSectionIntoView = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (!element) return false;

  element.scrollIntoView({ behavior: 'instant', block: 'start' });
  return true;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (pathname !== '/') return;

    const sectionId = hash.replace('#', '');

    if (sectionId && HOME_SECTION_IDS.has(sectionId)) {
      let attempts = 0;
      let frameId = 0;

      const tryScroll = () => {
        if (scrollSectionIntoView(sectionId)) return;

        if (attempts < 24) {
          attempts += 1;
          frameId = window.requestAnimationFrame(tryScroll);
        }
      };

      tryScroll();

      return () => {
        if (frameId) window.cancelAnimationFrame(frameId);
      };
    }

    if (hash) {
      window.history.replaceState(null, '', pathname);
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
};

export const HomeHashRedirect = ({ sectionId }) => (
  <Navigate to={{ pathname: '/', hash: `#${sectionId}` }} replace />
);

export default ScrollToTop;
